import { add } from "lodash";

const ga4TrackingUtility = "ga4TrackingUtility" in window ? window.ga4TrackingUtility : null;

const analyticsUtility = {
    addToCart(defaultVariationSku, products, quantity) {
        if (!ga4TrackingUtility) {
            return;
        }

        var items = JSON.parse(products);
        var addToCartItem = items.find(item => item.item_id === defaultVariationSku);
        ga4TrackingUtility.cartEcommerceEvent('add_to_cart', 'USD', addToCartItem.price * quantity, [addToCartItem]);
    },
    addPaymentInfo(coupon, paymentType, items) {
        if (!ga4TrackingUtility) {
            return;
        }

        var total = items.reduce(function(acc, item) {
            return acc + (item.price * item.quantity);
        }, 0);
        ga4TrackingUtility.addPaymentInfoEvent('USD', total, coupon, paymentType, items);
    },
    purchase(currency, value, transactionId, coupon, shipping, tax, items) {
        if (!ga4TrackingUtility) {
            return;
        }
        
        ga4TrackingUtility.purchaseEvent(currency, value, transactionId, coupon, shipping, tax, items);
    }
}
export default analyticsUtility;
